import statsig from "xAppLib/providers/statsig";
// Intercom has no way to remove an onShow handler. shutdown does clear them, so we have to register again
// after every boot - but not every boot follows a shutdown (login boots straight over the site-start boot),
// so older handlers can still be live. Only the newest registration is allowed to fire, so they can't
// double-log.
let latest_boot = 0;
const intercom = {
    boot(settings) {
        var _a, _b;
        (_a = window.Intercom) === null || _a === void 0 ? void 0 : _a.call(window, "boot", settings);
        const boot_id = ++latest_boot;
        (_b = window.Intercom) === null || _b === void 0 ? void 0 : _b.call(window, "onShow", () => {
            if (boot_id !== latest_boot)
                return;
            // Logged on every page and every open - Statsig attributes it to whichever experiment arms the
            // user is in.
            statsig.log_event("intercom_open");
        });
    },
};
export default intercom;
